/**
 * Block Initialization Utility
 *
 * Eliminates repeated DOM-ready / querySelectorAll / brixx:contentLoaded
 * boilerplate from individual block scripts.
 *
 * @package Brixx_Block_Framework
 * @since Brixx_Block_Framework 1.1.0
 */

/**
 * @param {string}   selector   - CSS selector for block root elements
 * @param {Function} initSingle - Called once per matched element
 * @returns {{ initAll: Function, initSingle: Function }}
 */
export function createBlockInit(selector, initSingle) {
	function initAll() {
		document.querySelectorAll(selector).forEach(el => initSingle(el));
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initAll);
	} else {
		initAll();
	}

	document.addEventListener('brixx:contentLoaded', initAll);

	return { initAll, initSingle };
}
